import { Injectable, TemplateRef } from '@angular/core';
import { ApiException } from '../models/models.swagger.generated';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  public toasts: any[] = [];

  public show(header: string, textOrTpl: string | TemplateRef<any>, placeholder: string = '', options: any = {}) {
    this.toasts.push({ header, textOrTpl, placeholder, ...options });
  }

  public showSuccess(header: string, textOrTpl: string | TemplateRef<any>, placeholder: string = '') {
    this.show(header, textOrTpl, placeholder, { classname: 'e-toast-success', delay: 10000, type: 'success' });
  }

  public showWarning(header: string, textOrTpl: string | TemplateRef<any>, placeholder: string = '') {
    this.show(header, textOrTpl, placeholder, { classname: 'e-toast-warning', delay: 15000, type: 'warning' });
  }

  public showError(header: string, textOrTpl: string | TemplateRef<any>, placeholder: string = '', errorId?: number, errorDetail?: string) {
    this.show(header, textOrTpl, placeholder, { classname: 'e-toast-danger', delay: 15000, type: 'error', errorId, errorDetail });
  }

  public showApiException(error: ApiException, title: string = 'i18n.errors.server-error.title', message: string = 'i18n.errors.server-error.message') {
    if (ApiException.isApiException(error)) {
      let detail;
      try{
        detail = JSON.parse(error.response).message;
      } catch(e) {
        detail = error.response;
      }

      if(!detail) {
       detail = error.response;
      }
      this.showError(title, message, '', undefined, detail);
    } else {
      this.showError(title, message);
    }
  }

  public remove(toast: any) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }

  public doesErrorExistAlready(errorId: number) {
    if (!errorId) {
      return false;
    }
    return this.toasts.find(t => t.errorId === errorId) != null;
  }
}
